import {Base64} from './Base64.js';
import MIMCUser from './mimc-min_1_0_2.js';
import {store} from '@/store/store'
import axios from 'axios'
import qs from "qs"	
var user = null;
var arr={};
function getMimcInfo(phone,status){
		var params = qs.stringify({
			phone:phone
		})
		axios.post('/goods/mimc/getParseTokenByH5',params)
		.then(userData=>{
			if(userData.data.resultCode="0000"){
		        arr["code"]=200 
		        arr["message"]='success'
		        arr["data"]=userData.data.resultInfo.parseToken		
				user = new MIMCUser(arr.data.appId, arr.data.appAccount);
			    user.registerFetchToken(fetchMIMCToken);
			    user.registerStatusChange(function(bindResult, errType, errReason, errDesc) {
						store.dispatch('getUser',{user:user,fetchMIMCTokenInfo:fetchMIMCToken()})
						status(bindResult)
					} ); 
				user.login();
				
			}else{
				this.$toast(userData.data.resultMsg);
			} 
		     status
		}).catch(error=>{
			console.log(error)
		})
}
function fetchMIMCToken() {
    return arr;
}
   
export{
	getMimcInfo
}



// WEBPACK FOOTER //
// ./src/xiaomi/mimc.js